import React from "react";
import Header2 from "../Header/Header2";
import Footer from "../Footer/Footer";
function PrincingOne() {
  return (
    <>
      <Header2></Header2>

      <section className="relative overflow-hidden py-10">
        <div className="relative mx-auto max-w-7xl px-4">
          <div className="mx-auto mb-24 max-w-2xl text-center lg:max-w-5xl">
            <h1 className="mb-2 text-4xl space-between font-bold tracking-tight text-white sm:text-6xl lg:text-7xl">
              <span>GET READY TO START THE JOURNEY</span>
            </h1>
            <p className="text-xl text-white-500 stroke-text">
              "The body achieves what the mind believes"
            </p>
          </div>
          <div className="mx-auto max-w-5xl">
            <div className="flex flex-wrap items-center">
              <div className="w-full lg:-mr-2 lg:w-1/3">
                <div className="mx-auto max-w-sm rounded-md border border-gray-200 bg-neutral-600 pb-20 pl-5 pr-8 pt-6 lg:pb-8">
                  <span className="mb-2 block text-sm font-semibold text-white">
                    PREMIUM
                  </span>
                  <span className="flex items-end">
                    <span className="text-4xl font-extrabold leading-none text-white ">
                      $150
                    </span>
                    <span className="text-sm font-semibold text-white">
                      /month
                    </span>
                  </span>
                  <div className="mt-7 border-t border-gray-100 pt-5">
                    <ul className="mb-10">
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          5 hours of exercise
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Free Consulation of the Coaches
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Access to the mini bar
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Personalized Training
                        </span>
                      </li>
                    </ul>
                    <button
                      type="button"
                      className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                      Choose Plan
                    </button>
                  </div>
                </div>
              </div>
              <div className="-mt-4 w-full lg:-mt-0 lg:w-1/3">
                <div className="pt-22 relative mx-auto max-w-sm rounded-lg bg-orange-600 px-10 pb-16 ">
                  <div className="absolute left-1/2 top-0 inline-flex -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-white p-2">
                    <div className="flex-shrink-0 rounded-full bg-orange-600 px-5 py-4 text-sm font-semibold uppercase text-white">
                      Most Popular
                    </div>
                  </div>
                  <span className="mb-2 block pt-10 text-sm font-semibold text-white">
                    GOLD
                  </span>
                  <span className="flex items-end text-white">
                    <span className="text-4xl font-extrabold leading-none">
                      $100
                    </span>
                    <span className="text-sm font-semibold">/month</span>
                  </span>
                  <div className="mt-7 border-t border-gray-100 pt-5">
                    <ul className="mb-10">
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          2 hours of exercises
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Basic Support
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Free Consulation of the trainer
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Free Diet Plan
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Free supliments for first month
                        </span>
                      </li>
                    </ul>
                    <button
                      type="button"
                      className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                      Choose Plan
                    </button>
                  </div>
                </div>
              </div>
              <div className="-mt-4 w-full lg:-ml-2 lg:-mt-0 lg:w-1/3">
                <div className="rounded-b-5xl lg:rounded-r-5xl mx-auto max-w-sm border border-gray-200 bg-neutral-600 pb-8 pl-8 pr-5 pt-12 lg:rounded-b-none lg:pt-6">
                  <span className="mb-2 block text-sm font-semibold text-white">
                    PRO
                  </span>
                  <span className="flex items-end">
                    <span className="text-4xl font-extrabold leading-none text-white">
                      $200
                    </span>
                    <span className="text-sm font-semibold text-white">
                      /month
                    </span>
                  </span>
                  <div className="mt-7 border-t border-gray-100 pt-5">
                    <ul className="mb-10">
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          7 hours of exercise
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Personal Trainer guidance
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          One Year suppliments
                        </span>
                      </li>
                      <li className="mb-6 flex items-center">
                        <span className="ml-2 text-sm text-white">
                          Access to the spa
                        </span>
                      </li>
                    </ul>
                    <button
                      type="button"
                      className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                      Choose Plan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
}

export default PrincingOne;
